module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header mb-3"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('el-page-header', {
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "content": "Automated Email Template Editor"
    },
    on: {
      "back": _vm.handleBack
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('loader', {
    attrs: {
      "msg": "Loading email template"
    }
  }) : _c('template-editor', {
    attrs: {
      "template": _vm.template
    },
    on: {
      "onCancel": _vm.handleCancel,
      "onSave": _vm.handleSave
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146e1d0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/admin/EmailComposerContainer.vue
// module id = 3148
// module chunks = 3